import { Switch } from '@eleo-rh/core-ui'
import { API_URL_ADMIN_ROOM_BOOKING_SWITCHER as apiURL } from 'constants/api'
import { useQuery } from 'context/QueryProvider'
import * as React from 'react'
import { useRouteLoaderData } from 'react-router-dom'
import type { Settings } from 'shared/types'

function RoomBookingSwitcher() {
  const settings = useRouteLoaderData('root') as Settings
  const { roomBookingEnabled } = settings
  const { client } = useQuery()
  const [loading, setLoading] = React.useState(false)

  const handleChange = async (checked: boolean) => {
    setLoading(true)

    await client.post(apiURL, checked)
    document.location.reload()
  }

  return (
    <Switch
      checked={Boolean(roomBookingEnabled)}
      onChange={handleChange}
      loading={loading}
      checkedChildren="Rés@"
      unCheckedChildren="Rés@"
    />
  )
}

export default RoomBookingSwitcher
